const selfActionURLs = [
  'http://localhost',
  'https://diyinbound-pre.herokuapp.com/',
  'https://app.diyinbound.com/dashboard/',
]

export const marked = require('marked')

// Set options
const renderer = new marked.Renderer()
renderer.link = (href, title, text) => {
  // in case of card activities linked
  let target = selfActionURLs.some((url) => href.includes(url)) ? '_self' : '_blank'
  // Adding target property to open links in a new tab.
  return `<a href="${href}" target="${target}">${text}</a>`
}

marked.setOptions({
  renderer,
  gfm: true,
  breaks: true,
  headerIds: false,
})
